<template>
  <div id="app">
	  <router-view></router-view>
  </div>
</template>

<script>
import DefaultLayout from './layouts/DefaultLayout.vue'

export default {
  components: {
	DefaultLayout
  },
  mounted(){
	  
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;/*字体*/
  -webkit-font-smoothing: antialiased;/*图标字体抗锯齿*/
  -moz-osx-font-smoothing: grayscale;/*字体平滑啥的,ios*/
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
